import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  scheduleTitle: {
    fontWeight: 600,
    fontSize: '1rem'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  addDescriptionLink: {
    fontSize: '.875rem',
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',

    '&.disabled': {
      color: theme.palette.disabled.main,
      cursor: 'auto'
    }
  },
  editor: {
    '&.activeEdit': {
      '& .ql-container, .ql-editor': {
        minHeight: 430,
        [theme.breakpoints.up('sm')]: {
          minHeight: 300
        }
      }
    },
    '&.error': {
      '& .ql-toolbar': {
        border: `1px solid ${theme.palette.error.main}`
      },
      '& .ql-container': {
        border: `1px solid  ${theme.palette.error.main}`
      },
      '& .ql-editor': {
        '&:focus': {
          border: `1px solid  ${theme.palette.error.main}`
        }
      }
    }
  }
}))
